import { boolean, literal, object, optional, string } from 'superstruct';

import { adflowApiSchema } from '@adflow/shared/util-route-schema';
import { ViewAuthUserDto } from '@adflow/shared/util-users';

import { AddPasswordResetDto } from './add-password-reset.dto';
import {
	ChangePasswordDto,
	CheckResetPasswordTokenDto,
	LoginDto,
	ResetPasswordTokenInfoDto,
} from './login.dto';

const p = adflowApiSchema.prefix('auth');

export const Login = p.post('login', {
	req: object({
		body: LoginDto,
	}),
	res: ViewAuthUserDto,
});

export const Logout = p.get('logout', {
	req: object({}),
	res: literal(undefined),
});

export const GetSession = p.get('session', {
	req: object({}),
	res: optional(ViewAuthUserDto),
});

export const SsoCapability = p.get('sso-capability', {
	req: object({}),
	res: object({ microsoftEnabled: boolean() }),
});

/**
 * Request a reset password token. If the user exists an email will be sent with
 * the token.
 */
export const ResetPassword = p.post('reset-password', {
	req: object({
		body: AddPasswordResetDto,
	}),
	res: literal(undefined),
});

export const CheckResetPasswordToken = p.post('check-reset-password-token', {
	req: object({
		body: CheckResetPasswordTokenDto,
	}),
	res: ResetPasswordTokenInfoDto,
});

/**
 * Use a reset password token to change the user's password.
 */
export const ChangePassword = p.post('change-password', {
	req: object({ body: ChangePasswordDto }),
	res: object({ email: string() }),
});
